module.exports = __webpack_public_path__ + "img/logo_list4.3756429f.png";